import React, { Component } from "react";
import Titulo from "../../generico/TituloPagina";
import Popup from 'react-popup';
import $ from "jquery";
import DatosSocio from "../../generico/DatosSocio"
import SugerenciasService from "../../../services/sugerencias/SugerenciasService.js";
import { trackPromise } from "react-promise-tracker";
import ConfigService from "../../../services/configuracion/ConfigService";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faCloudArrowUp, faPaperPlane  } from "@fortawesome/free-solid-svg-icons";


const CANT_LIMITE_IMAGENES = 3;
const ID_SECTOR_ATENCION = 5;
const ID_SECTOR_AHORROS = 3;
const ID_SECTOR_CU24HS = 7;
const ID_MOTIVO_OTROS = 11;

const CustomSelect = ({ list, id, name, title, placeholder, value, onChange, renderIf = true }) => {
    return (renderIf &&
        <div className="form-group">
            <label htmlFor={id} className="input-label-bold">{title}</label>
            <select onChange={onChange} value={value} name={name} id={id} className="custom-select">
                <option value="" disabled>{placeholder}</option>
                {list.map(({ label, value }, index) =>
                    <option value={value} key={index}>{label}</option>
                )}
            </select>
        </div>
    )
}

export default class Sugerencias extends Component {

    modulos = [];

    constructor(props) {

        super(props);
        this.cargarImagen = this.cargarImagen.bind(this);
        this.clickImageClose = this.clickImageClose.bind(this);
        this.clickInputImage = this.clickInputImage.bind(this);
        this.enviar = this.enviar.bind(this);
        this.blobToBase64 = this.blobToBase64.bind(this);
        this.changeInputSugerencia = this.changeInputSugerencia.bind(this);
        this.getBase64FromUrl = this.getBase64FromUrl.bind(this);

        this.state = {
            modulo: "",
            sugerencia: "",
            sector: "",
            sucursal: "",
            plataforma: "",
            inconveniente: "",
            imagenesCaptura: [],
            imagenesNombre: [],
            listaModulos: [],
            listaSectores: [],
            listaSucursales: [],
            listaPlataformas: [],
            listaInconveniente: [],
            listaParametrosSectores: []
        };

    }

    componentDidMount() {
        this.habilitarDragAndDrop();
        this.agregarValidacionFormulario();
        this.obtenerParametros();
    }

    listarSucursales = () => {
        trackPromise(
            ConfigService.obtenerSucursalesCercanas().then(response => {

                let { data } = response;

                if (data.codigoRetorno === "0") {
                    let arraySucursales = data.datos.map(value => (
                        { label: value.nombreSucursal, value: value.codigo }
                    ))
                    this.setState({ listaSucursales: arraySucursales });
                } else {
                    Popup.queue(this.notifiPopup("Info", "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."));
                }

            }).catch(error => {
                console.log(error);
                Popup.queue(this.notifiPopup("Error", "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."));
            })
        )
    }

    inicializarEstados = () => {
        this.setState({
            modulo: "",
            sugerencia: "",
            sector: "",
            sucursal: "",
            plataforma: "",
            inconveniente: "",
            imagenesCaptura: [],
            imagenesNombre: [],
            listaModulos: [],
            listaInconveniente: []
        });
    }

    obtenerParametros = () => {
        trackPromise(
            SugerenciasService.obtenerParametros()
                .then(({ data }) => {

                    if (data.codigoRetorno === 0) {

                        let { listaSectores, listaPlataformas } = this.state;

                        console.log(data.datos.sectorList);

                        listaPlataformas = data.datos.plataformaList.map(plataforma => ({
                            value: plataforma.id,
                            label: plataforma.nombre
                        }));

                        listaSectores = data.datos.sectorList.map(sector => ({
                            value: sector.id,
                            label: sector.descripcion
                        }));

                        this.setState({
                            listaSectores,
                            listaPlataformas,
                            listaParametrosSectores: data.datos.sectorList
                        });

                    } else {
                        Popup.queue(this.notifiPopup("Info", "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."));
                    }

                })
                .catch(error => {
                    console.log(error);
                    Popup.queue(this.notifiPopup("Error", "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."));
                })
        )
    }

    agregarValidacionFormulario = () => {

        $("#idSugerenciaForm").on("submit", (e) => {
            e.preventDefault();
        }).validate({
            rules: {
                input_sugerencia: {
                    required: true,
                },
                select_modulo: {
                    required: true
                },
                select_sector: {
                    required: true
                },
                select_sucursal: {
                    required: true
                },
                select_plataforma: {
                    required: true,
                },
                select_inconveniente: {
                    required: true,
                },
            },
            messages: {
                input_sugerencia: {
                    required: "Este campo es requerido",
                },
                select_modulo: {
                    required: "Este campo es requerido",
                },
                select_sector: {
                    required: "Este campo es requerido",
                },
                select_sucursal: {
                    required: "Este campo es requerido",
                },
                select_plataforma: {
                    required: "Este campo es requerido",
                },
                select_inconveniente: {
                    required: "Este campo es requerido",
                }
            },
            errorElement: "span",
            errorPlacement: function (error, element) {
                error.addClass("invalid-feedback");
                $(element).addClass("is-invalid");
                element.closest(".form-group").append(error);

            },

            unhighlight: function (element, errorClass, validClass) {
                $(element).removeClass("is-invalid");
            },
            submitHandler: () => { this.enviar() }

        });
    }

    handleChangeSelector = (selectedOption) => {
        if (selectedOption === null)
            this.setState({
                plazo: undefined
            });
        else
            this.setState({
                plazo: selectedOption.value
            });
    };


    getBase64FromUrl = async (url) => {
        const data = await fetch(url);
        const blob = await data.blob();
        return new Promise((resolve) => {
            const reader = new FileReader();
            reader.readAsDataURL(blob);
            reader.onloadend = () => {
                const base64data = reader.result;
                resolve(base64data);
            }
        });
    }


    enviar = async () => {

        let imgArray = this.state.imagenesCaptura;

        let base64Array = [];
        let base64 = null;

        for (let index = 0; index < imgArray.length; index++) {
            const img = imgArray[index];

            base64 = await this.blobToBase64(img);

            let extension = img.name.split(".");
            extension = extension[extension.length - 1];

            base64Array.push({ nombre: img.name, extension, base64 });
        }

        let formData = {
            modulo: this.state.modulo,
            sugerencia: this.state.sugerencia,
            sector: this.state.sector,
            sucursal: this.state.sucursal,
            plataforma: this.state.plataforma,
            inconveniente: this.state.inconveniente,
            canal: "WEB",
            imagenes: base64Array,
        }

        trackPromise(
            SugerenciasService.enviarSugerencias(formData)
                .then(response => {

                    let { codigoRetorno } = response.data;

                    if (codigoRetorno === 0) {
                        Popup.queue(this.notifiPopup("Info", "Sugerencia registrada."));
                        this.inicializarEstados();
                    } else {
                        Popup.queue(this.notifiPopup("Error", "Error Inesperado, por favor intente nuevamente."));
                    }

                })
                .catch(error => {
                    Popup.queue(this.notifiPopup("Info", "Error Inesperado. Intenta volver a recargar esta página o no dudes en contactar con nosotros si el problema persiste."));
                })
        )

    }

    //convertir imagen a base64
    blobToBase64 = blob => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(blob);
        reader.onload = () => resolve(reader.result);
        reader.onerror = error => reject(error);
    });


    notifiPopup = (titulo, mensaje) =>
        Popup.register({
            title: titulo,
            content: mensaje,
            buttons: {
                right: [
                    {
                        text: "Aceptar",
                        className: "success",
                        action: function () {
                            Popup.close();
                        },
                    },
                ],
            },
        });


    habilitarDragAndDrop = () => {

        window.addEventListener("paste", e => {
            if (e.clipboardData.files.length > 0)
                this.cargarImagen(e.clipboardData.files);
        });

        document.querySelector("#divImgDrop").addEventListener("drop", e => {
            $("#divImgDrop").css("outline-offset", "0");
            e.preventDefault();
            if (e.dataTransfer.files.length > 0)
                this.cargarImagen(e.dataTransfer.files);
        });

        document.querySelector("#divImgDrop").addEventListener("dragenter", e => {
            e.preventDefault();
        });


        window.addEventListener("dragover", e => {
            let imgDrop = document.querySelector("#divImgDrop");

            let objetivoCorrecto = false;

            if (imgDrop === e.target || $(imgDrop).find(e.target).length > 0) objetivoCorrecto = true;

            if (objetivoCorrecto) {
                $("#divImgDrop").css("outline-offset", "-1rem");
            } else {
                $("#divImgDrop").css("outline-offset", "0");
            }

            e.preventDefault();
        });


        window.addEventListener("drop", e => {
            e.preventDefault();
        });

    }

    cargarImagen = (fileList) => {

        let imagenesCaptura = this.state.imagenesCaptura;
        let imagenesNombre = this.state.imagenesNombre;

        // si ya existen 3 imagenes almacenadas
        if (imagenesCaptura.length === CANT_LIMITE_IMAGENES) {
            Popup.queue(this.notifiPopup("Info", `Ya seleccionó ${CANT_LIMITE_IMAGENES} imágenes, elimine alguna para agregar una nueva imágen.`));
            return null;
        }

        let cantImgDisponible = (CANT_LIMITE_IMAGENES - imagenesCaptura.length);

        let limite = fileList.length <= cantImgDisponible ? fileList.length : cantImgDisponible;

        let archivosOmitidos = [];
        let archivosNoPermitidos = [];

        for (let index = 0; index < fileList.length; index++) {

            let file = fileList[index];

            if (file.type.indexOf("image") > -1) {
                if (index < limite) {
                    imagenesCaptura.push(file);
                    imagenesNombre.push(file.name);
                } else {
                    archivosOmitidos.push(file.name);
                }
            } else {
                archivosNoPermitidos.push(file.name);
            }

        }

        if (archivosNoPermitidos.length > 0) {
            Popup.queue(this.notifiPopup("Info", "Sólo se permiten imágenes"));
        }

        if (archivosOmitidos.length > 0) {
            Popup.queue(this.notifiPopup("Info",
                <div>
                    <p>Se omitieron las siguientes imágenes, ya que se superó la cantidad permitida.</p>
                    <ul>
                        {
                            archivosOmitidos.map(archivo => <li>&bull; {archivo}</li>)
                        }
                    </ul>
                </div>
            ));
        }

        this.setState({ imagenesCaptura });
        this.setState({ imagenesNombre });
    }

    clickImageClose = (e) => {

        let imagenesCaptura = this.state.imagenesCaptura;
        let imagenesNombre = this.state.imagenesNombre;
        let indexImg = parseInt(e.target.parentElement.getAttribute("id"));

        let fileList = document.querySelector("#inputImg").files;

        let newFileList = new DataTransfer();

        Object.keys(fileList).forEach((value, index) => {

            if (index === indexImg) return null;

            newFileList.items.add(fileList[value]);

        });

        document.querySelector("#inputImg").files = newFileList.files;

        imagenesCaptura = imagenesCaptura.filter((value, index) => index !== indexImg);
        imagenesNombre = imagenesNombre.filter((value, index) => index !== indexImg);

        this.setState({ imagenesCaptura });
        this.setState({ imagenesNombre });

    }

    clickInputImage = () => {
        $("#inputImg").trigger("click");
    }

    changeInputImage = (e) => {
        this.cargarImagen(e.target.files);
    }

    changeInputSugerencia = (e) => {
        this.setState({ sugerencia: e.target.value });
    }

    changeSelectModulo = (e) => {

        let { listaInconveniente, listaParametrosSectores, sector } = this.state;

        let moduloSeleccionado = parseInt(e.target.value);

        // agregar lista de inconveniente
        listaInconveniente = listaParametrosSectores.find(parametroSector => parametroSector.id === sector)?.moduloList
            .find(modulo => modulo.id === moduloSeleccionado)?.inconvenienteList
            .map(inconveniente => ({ value: inconveniente.id, label: inconveniente.descripcion }))

        this.setState({ modulo: moduloSeleccionado, inconveniente: "", listaInconveniente })

    }

    changeSelectInconveniente = (e) => {
        let inconvenienteSeleccionado = parseInt(e.target.value)
        this.setState({ inconveniente: inconvenienteSeleccionado })
    }

    changeSelectSector = (e) => {

        let { listaModulos, listaParametrosSectores, listaInconveniente } = this.state;

        let sectorSeleccionado = parseInt(e.target.value);

        if (sectorSeleccionado === ID_SECTOR_ATENCION && this.state.listaSucursales.length === 0)
            this.listarSucursales();

        if (sectorSeleccionado !== ID_SECTOR_ATENCION) this.setState({ sucursal: "" });
        if (sectorSeleccionado !== ID_SECTOR_CU24HS) this.setState({ plataforma: "" });

        // agregar lista de modulos
        listaModulos = listaParametrosSectores.find(sector => sector.id === sectorSeleccionado)?.moduloList
            .filter(modulo => modulo.id !== 0)
            .map(modulo => ({ value: modulo.id, label: modulo.descripcion }));

        if (listaModulos.length === 0) {

            listaInconveniente = listaParametrosSectores.find(sector => sector.id === sectorSeleccionado)?.moduloList
                .find(modulo => modulo.id === 0)?.inconvenienteList
                .map(inconveniente => ({ value: inconveniente.id, label: inconveniente.descripcion }))

        } else {
            listaInconveniente = [];
        }

        this.setState({ sector: sectorSeleccionado, modulo: "", listaModulos, inconveniente: "", listaInconveniente })

    }

    changeSelectSucursal = (e) => {
        let sucursalSeleccionada = parseInt(e.target.value)
        this.setState({ sucursal: sucursalSeleccionada });
    }

    changeSelectPlataforma = (e) => {
        let plataformaSeleccionada = parseInt(e.target.value)
        this.setState({ plataforma: plataformaSeleccionada });
    }

    render() {

        return (
            <div className="content-wrapper">
                <Titulo texto="Tu opinión es importante" />
                <section className="content">
                    <form id="idSugerenciaForm">
                        <div className="container">
                            <div className="row justify-content-md-center">
                                <div className="col-md-10">
                                    <div className="card">
                                        <div className="card-header">
                                            <DatosSocio />
                                        </div>
                                        <div className="card-body">
                                            <div className="row">
                                                <div className="col-md-12">

                                                    {/* sectores */}
                                                    <CustomSelect
                                                        list={this.state.listaSectores}
                                                        id={"idSelectModulo"}
                                                        name={"select_sector"}
                                                        title={"Cree que podríamos mejorar en nuestro servicio de *"}
                                                        placeholder={"Seleccione el servicio"}
                                                        value={this.state.sector}
                                                        onChange={this.changeSelectSector}
                                                    />

                                                    {/* sucursales */}
                                                    <CustomSelect
                                                        list={this.state.listaSucursales}
                                                        id={"idSelectSucursal"}
                                                        name={"select_sucursal"}
                                                        title={"Seleccione la Sucursal *"}
                                                        placeholder={"Seleccione la Sucursal"}
                                                        value={this.state.sucursal}
                                                        onChange={this.changeSelectSucursal}
                                                        renderIf={this.state.sector === ID_SECTOR_ATENCION && this.state.listaSucursales.length > 0}
                                                    />

                                                    {/* plataformas */}
                                                    <CustomSelect
                                                        list={this.state.listaPlataformas}
                                                        id={"idSelectPlataforma"}
                                                        name={"select_plataforma"}
                                                        title={"Plataforma *"}
                                                        placeholder={"Seleccione la plataforma"}
                                                        value={this.state.plataforma}
                                                        onChange={this.changeSelectPlataforma}
                                                        renderIf={this.state.sector === ID_SECTOR_CU24HS}
                                                    />

                                                    {/* modulos */}
                                                    <CustomSelect
                                                        list={this.state.listaModulos}
                                                        id={"idSelectModulo"}
                                                        name={"select_modulo"}
                                                        title={"Tipo de Servicio *"}
                                                        placeholder={"Seleccione el tipo de servicio"}
                                                        value={this.state.modulo}
                                                        onChange={this.changeSelectModulo}
                                                        renderIf={this.state.listaModulos.length > 0}
                                                    />

                                                    {/* inconveniente */}
                                                    <CustomSelect
                                                        list={this.state.listaInconveniente}
                                                        id={"idSelectInconveniente"}
                                                        name={"select_inconveniente"}
                                                        title={"Motivo *"}
                                                        placeholder={"Seleccione el motivo"}
                                                        value={this.state.inconveniente}
                                                        onChange={this.changeSelectInconveniente}
                                                        renderIf={this.state.listaInconveniente.length > 0}
                                                    />


                                                    <div className="form-group">
                                                        <label className="input-label-bold">Sugerencia *</label>
                                                        <textarea
                                                            name="input_sugerencia"
                                                            cols="50"
                                                            rows="5"
                                                            maxLength={500}
                                                            value={this.state.sugerencia}
                                                            className="form-control text-sugerencia"
                                                            onChange={this.changeInputSugerencia}
                                                        ></textarea>
                                                    </div>
                                                  

                                                    {
                                                        (this.state.inconveniente === ID_MOTIVO_OTROS || this.state.sector === ID_SECTOR_AHORROS || this.state.sector === ID_SECTOR_CU24HS ) &&
                                                        <div className="form-group">
                                                            <label className="input-label-bold">Sugerencia *</label>
                                                            <textarea
                                                                name="input_sugerencia"
                                                                cols="50"
                                                                rows="5"
                                                                maxLength={500}
                                                                value={this.state.sugerencia}
                                                                className="form-control"
                                                                onChange={this.changeInputSugerencia}
                                                            ></textarea>
                                                        </div>
                                                    }
                                                    <div className="form-group" hidden={this.state.sector !== ID_SECTOR_CU24HS}>

                                                        <label className="input-label-bold">Capturas de Pantalla (max. 3 imágenes)</label>
                                                        <div id="divImgDrop" className="img-drop">
                                                            <FontAwesomeIcon icon={faCloudArrowUp} className="icondopdown" style={{fontSize:"2rem"}} id="iconCloud" />
                                                            <p>Arrastre la imágen hasta aquí</p>
                                                            <p>O</p>
                                                            <button className="btn btn-cu-primary" onClick={this.clickInputImage} type="button">Seleccione una imágen</button>
                                                            <input name="input_imagen" className="d-none" multiple type="file" id="inputImg" accept="image/png,image/jpeg" onChange={this.changeInputImage} />
                                                        </div>
                                                    </div>
                                                    <div className="row mb-2" name="image_content" hidden={this.state.sector !== ID_SECTOR_CU24HS}>
                                                        {/* se comenta porque en produccion no se previsualizan las imagenes por un error de
                                                        Content Security Policy 
                                                        {this.state.imagenesCaptura.map((blob, index) => {
                                                            let url = URL.createObjectURL(blob);
                                                            return (
                                                                <div id={index} key={index} className="h-75 mb-2 col-md-4">
                                                                    <i onClick={this.clickImageClose} className="fas fa-times-circle close-image"></i>
                                                                    <img className="imagen-sugerencia" width="100%" height="75%" src={url} alt="" />
                                                                    <span>prueba</span>
                                                                </div>
                                                            )
                                                        })} */}
                                                        {this.state.imagenesNombre.map((nombre, index) => {
                                                            return (
                                                                <div id={index} key={index} className="col-md-4 imagen-sugerencia">
                                                                    <i onClick={this.clickImageClose} className="fas fa-times-circle close-image"></i>
                                                                    <span>{nombre}</span>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        <div className="card-footer">
                                            <div className="row">
                                                <div className="col-lg-10 col-md-6">
                                                <label className="input-label-bold-obligatorio float-left">
                                                (*) Campos Obligatorios
                                            </label>
                                                </div>
                                                <div className="col-lg-2 col-md-6">
                                                <button className="btn btn-cu-primary float-right">
                                               <FontAwesomeIcon icon={faPaperPlane} /> Enviar
                                            </button>
                                                </div>
                                            </div>
                                            
                                           
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </section>
            </div >
        );
    }
}
